// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"577d9e65","105":"21a62d75","138":"5b00cab6","317":"693a8ebe","326":"e0b9f4fb","414":"c4b029fb","432":"4632fede","438":"ea165614","440":"a4418117"}[chunkId] + ".chunk.js";
};